export const API_BASE_URL = '/webpub-services';
export const ACCESS_TOKEN = 'accessToken';